<template>
  <div style="display: flex;flex-direction: column;align-items: center;justify-content: flex-start;width: 100%">
    <div id="mainContentWrapper"
         style="width: 100%;min-width:1000px;display: flex;flex-direction: column;align-items: center;justify-content: flex-start"
         bgScroll="none">
      <Header/>
      <Banner/>
      <div v-html="detail" class="out-content"/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from "@/components/Footer"
import Header from "@/components/Header"
import Banner from "@/components/Banner"
import http from "@/util/http";

export default {
  name: "DetailPage",
  components: {Banner, Header, Footer},
  data() {
    return {
      detail: undefined
    }
  },
  mounted() {
    this._getDetail()
  },
  methods: {
    _getDetail() {
      http.get('articleDetail', {
        id: this.$route.query.id
      })
          .then((res) => {
            if (res.data.status === 0) {
              const resultData = res.data.data
              this.detail = resultData.post_content
            }
          })
    }
  }
}
</script>

<style scoped>
.out-content {
  /*display: flex;*/
  /*flex-direction: column;*/
  /*align-items: flex-start;*/
  /*justify-content: flex-start;*/
  max-width: 1000px;
  width: 100%;
}

/deep/ table {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

/deep/ tbody {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

/deep/ table td, table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}

/deep/ table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
  /*}*/
  /*/deep/ img {*/
  /*  width: 1000px;*/
  /*  height: auto;*/
  /*  object-fit: contain;*/
}
</style>